(function () {
  if (customElements.get('cogi-review-carousel')) return;

  class CogiReviewCarousel extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.track = this.querySelector('.crv__track');
      this.slides = [].slice.call(this.querySelectorAll('.crv__slide'));
      this.index = 0;

      var prev = this.querySelector('[data-crv-prev]');
      var next = this.querySelector('[data-crv-next]');
      var nav = this.querySelector('.crv__nav');

      // A single review needs no controls.
      if (this.slides.length < 2) {
        if (nav) nav.hidden = true;
        return;
      }

      if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); self.go(self.index - 1); });
      if (next) next.addEventListener('click', function (e) { e.preventDefault(); self.go(self.index + 1); });

      // Swipe on touch devices.
      var startX = null;
      this.track.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
      }, { passive: true });
      this.track.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 40) self.go(self.index + (dx < 0 ? 1 : -1));
        startX = null;
      }, { passive: true });

      this.go(0);
    }

    go(i) {
      var n = this.slides.length;
      if (!n) return;
      this.index = ((i % n) + n) % n;
      this.track.style.transform = 'translateX(' + (this.index * -100) + '%)';
      for (var s = 0; s < n; s++) {
        this.slides[s].setAttribute('aria-hidden', s === this.index ? 'false' : 'true');
      }
    }
  }

  customElements.define('cogi-review-carousel', CogiReviewCarousel);
})();
